<form [formGroup]="mapSettingsForm" >
<div mat-dialog-content class="dialog-content">
  <h1 mat-dialog-title>Settings</h1>
  <section class="dialog-section">
    <p class="dialog-section-title">Display Options</p>
    <div class="dialog-section-content">
      <mat-checkbox  name="milesDistance" formControlName="milesDistance">Display the distance in miles</mat-checkbox>
      <mat-checkbox  name="waypointNumber" formControlName="waypointNumber">Display waypoint numbers</mat-checkbox>
      <mat-checkbox  name="addWayPointPrompt" formControlName="addWayPointPrompt">Display confirm prompt</mat-checkbox>
      <mat-form-field appearance="fill">
        <mat-label>Coordinate</mat-label>
        <mat-select  name="selectedCoordinate" formControlName="selectedCoordinate">
          <mat-option [value]="0">Decimal Degrees</mat-option>
          <mat-option [value]="1">Degree/Minutes</mat-option>
          <mat-option [value]="2">Degree/Minutes/Seconds</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </section>
  <section  class="dialog-section">
    <p class="dialog-section-title">Itinerary Options</p>
    <div class="dialog-section-content">
      <mat-checkbox  name="recalculateItinerary" formControlName="recalculateItinerary">Automatically recalculate the itinerary</mat-checkbox>
      <mat-checkbox  name="addRouteDirectly" formControlName="addRouteDirectly" aria-disabled="true" disabled>Directly add a stage when clicking on route</mat-checkbox>
      <mat-checkbox  name="waypointsOnRoad" formControlName="waypointsOnRoad">Place waypoints on road</mat-checkbox>
      
      <mat-form-field appearance="fill" style=" margin: 0.6rem 0.6rem 0 0;" >
        <mat-label >Route Interval</mat-label>
        <mat-select name="selectedRouteInterval"  formControlName="selectedRouteInterval" >
          <mat-option *ngFor="let route of routeIntervalList" [value]="route.id">{{route.intervalTime}}</mat-option>
           </mat-select>
      </mat-form-field>
   
      <div >
      <button mat-raised-button color="primary" class="reloadButton" type="button"  (click)="reloadFile()">Reload Waypoints</button>
      </div>
      <mat-form-field appearance="fill" style=" margin: 0.6rem 0.6rem 0 0;">
        <mat-label >Direction Provider</mat-label>
        <mat-select name="selectedDirectionProvider" formControlName="selectedDirectionProvider" >
            <mat-option *ngFor="let provider of mapOptions" [value]="provider[0]">{{provider[0]}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill" style=" margin: 0.6rem 0.6rem 0 0;">
        <mat-label>Vehicle</mat-label>
        <mat-select name="selectedVehicle" formControlName="selectedVehicle" [compareWith]="compareWithVehicle">
          <mat-option *ngFor="let vehicle of vehicleList" [value]="vehicle.name">{{vehicle.displayName}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill" style=" margin: 0.6rem 0.6rem 0 0;">
        <mat-label>Driving direction</mat-label>
        <mat-select  name="selectedDrivingDirection" formControlName="selectedDrivingDirection">
          <mat-option *ngFor="let direction of drivingDirectionList" [value]="direction[1]">{{direction[0]}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-checkbox  name="avoidHighways" formControlName="avoidHighways">Avoid Highways</mat-checkbox>
      <mat-checkbox  name="avoidTolls" formControlName="avoidTolls">Avoid Tolls</mat-checkbox>
    </div>
  </section>
  <section  class="dialog-section" *ngIf="mapTypes.length" >
    <p class="dialog-section-title">Map Options</p>
    <app-multi-select *ngFor="let type of mapTypes"
                      [sourceData]="type"
                      (selectedItems)="getMapTypes($event, type.name)"
                      ></app-multi-select>
  </section>
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="closeDialog()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSubmit()">Ok</button>
 
</div>
</form>
